import React from 'react'
import { useStore } from '../../../../../lib/context'
import {motion} from 'framer-motion'
import { observer } from 'mobx-react-lite'
import SearchIcon from '../../../Icons/SearchIcon'
const NavModuleSearchBar = observer(() => {
    const {articleQueryStore: {updateIsSearching, activeDataQueryID}} = useStore()

    
    return (
        <motion.div 
            key="nm-s-bar"
            className='nav-module-search-bar flex--center'
            onClick={() => updateIsSearching(true)}
            initial={{ opacity: 0, y: 3}}
            animate={{ opacity: 1, y: 0}}
            exit={{ opacity: 0, y: -1}}
            transition={{delay: .25}}
        >
            <SearchIcon/>
            <span className={`label ${!!activeDataQueryID ? "active" : ""}`}>
                Filter
            </span>

        </motion.div>
    )
})





export default NavModuleSearchBar